// Müşteri Yönetimi sayfası ve modalları için metinler.
const customers = {
  title: 'Müşteri Yönetimi',
  subtitle: 'Müşterileri arayın, filtreleyin; anlaşma, adres ve yetkili bilgilerini yönetin.',
  listLabel: 'Müşteri listesi',
  yes: 'Evet',
  no: 'Hayır',
  domestic: 'Yurtiçi',
  abroad: 'Yurtdışı',
  paymentDays_one: '{{count}} gün',
  paymentDays_other: '{{count}} gün',
  status: {
    active: 'Aktif',
    inactive: 'İnaktif',
    all: 'Tümü',
    unknown: 'Belirtilmemiş',
  },
  stats: {
    total: 'Toplam Müşteri',
    totalShort: 'Toplam',
    active: 'Aktif Müşteri',
    activeShort: 'Aktif',
    inactive: 'İnaktif Müşteri',
    inactiveShort: 'İnaktif',
    share: 'Tüm müşteriler içindeki payı: %{{percent}}',
  },
  actions: {
    add: 'Yeni Müşteri Ekle',
    download: 'Tabloyu İndir',
    downloadHint: 'Tüm müşterileri tabloda görünen sütunlarla Excel olarak indir',
  },
  search: {
    placeholder: 'İsim, bilgi veya vergi numarası ile ara…',
    placeholderShort: 'Müşteri, bilgi veya VKN ara…',
    label: 'Müşteri ara (en az 3 karakter)',
  },
  columns: {
    title: 'Başlık',
    info: 'Bilgi',
    status: 'Durum',
    agreementDate: 'Ana Anlaşma Tarihi',
    agreementNumber: 'Ana Anlaşma Numarası',
    currency: 'Döviz Tipi',
    serviceNumber: 'Müşteri Hizmet Numarası',
    deliveryDate: 'Teslim Tarihi',
    taxNumber: 'Vergi Numarası',
    domestic: 'Yurtiçi mi?',
    paymentPeriod: 'Ödeme Periyodu',
  },
  options: {
    monthly: 'Aylık',
    quarterly: '3 Aylık',
    halfYearly: '6 Aylık',
    yearly: 'Yıllık',
  },
  table: {
    empty: 'Filtrelere uygun müşteri bulunamadı',
  },
  pagination: {
    rangeOf: '/ {{total}} müşteri',
    ofTotal: 'toplam {{total}} müşteri içinden',
  },
  panel: {
    label: 'Müşteri ayrıntıları',
    heading: 'Müşteri',
    card: 'Müşteri Kartı',
    edit: 'Düzenle',
    addresses: 'Adresler',
    personnel: 'Yetkililer',
    deactivate: 'İnaktif Yap',
    activate: 'Aktif Yap',
    statusHint: 'Müşterinin durumunu değiştir',
  },
  toast: {
    loadError: 'Müşteriler yüklenirken hata oluştu',
    excelPreparing: 'Excel dosyası hazırlanıyor...',
    excelSuccess: 'Excel dosyası başarıyla indirildi',
    excelError: 'Excel dosyası indirilemedi',
  },
  common: {
    save: 'Kaydet',
    update: 'Güncelle',
    saving: 'Kaydediliyor…',
    cancel: 'İptal',
    back: 'Listeye dön',
    edit: 'Düzenle',
    delete: 'Sil',
    deleting: 'Siliniyor…',
    keep: 'Vazgeç',
    loading: 'Yükleniyor…',
  },
  card: {
    title: 'Müşteri Kartı',
    edit: 'Düzenle',
    summary: 'Özet',
    totalProjects: 'Toplam Proje',
    activeProjects: 'Aktif Proje',
    people: 'Yetkili Kişi',
    tariffs: 'Tanımlı Tarife',
    company: 'Kurum Bilgileri',
    name: 'Müşteri Adı',
    agreement: 'Anlaşma Bilgileri',
    addresses: 'Adresler ({{count}})',
    defaultAddress: 'Varsayılan Adres',
    address: 'Adres',
    cityDistrict: 'İl / İlçe',
    fullAddress: 'Açık Adres',
    noAddress: 'Kayıtlı adres bulunmuyor.',
    personnel: 'Yetkili Kişiler ({{count}})',
    noPersonnel: 'Kayıtlı yetkili kişi bulunmuyor.',
    personFallback: 'Yetkili',
    morePersonnel: '+{{count}} kişi daha',
    manage: 'Yönet',
    loadError: 'Müşteriye bağlı kayıtlar yüklenemedi',
  },
  form: {
    addTitle: 'Yeni Müşteri Ekle',
    editTitle: 'Müşteriyi Düzenle',
    addSubtitle: 'Kurum ve anlaşma bilgilerini girin',
    company: 'Kurum Bilgileri',
    agreement: 'Anlaşma ve Ödeme',
    fields: {
      name: 'Müşteri Adı',
      nameHint: 'Büyük harfle kaydedilir',
      info: 'Bilgi',
      agreementNumber: 'Ana Anlaşma Numarası',
      agreementDate: 'Ana Anlaşma Tarihi',
      status: 'Durum',
      currency: 'Döviz Tipi',
      serviceNumber: 'Müşteri Hizmet Numarası',
      endDate: 'Sözleşme Bitiş Tarihi',
      endDateHint: 'Tabloda "Teslim Tarihi" sütununda görünür',
      taxNumber: 'Vergi Numarası',
      domestic: 'Yurtiçi mi?',
      paymentPeriod: 'Ödeme Periyodu',
      paymentPeriodHint: 'Gün sayısı',
    },
    errors: {
      nameRequired: 'Müşteri adı zorunludur',
      paymentInvalid: 'Ödeme periyodu geçerli bir sayı olmalıdır',
    },
    submitAdd: 'Kaydet',
    submitEdit: 'Güncelle',
    shortcut: 'Ctrl + Enter ile kaydet',
    toast: {
      fixErrors: 'Lütfen form hatalarını düzeltin',
      added: 'Yeni müşteri başarıyla eklendi!',
      addError: 'Yeni müşteri eklenemedi: {{message}}',
      updated: 'Müşteri başarıyla güncellendi!',
      updateError: 'Müşteri güncellenemedi: {{message}}',
      notFound: 'Güncellenecek müşteri bulunamadı',
    },
  },
  statusChange: {
    title: 'Durumu Değiştir',
    toInactive: "Bu müşterinin durumunu aktif'ten inaktif'e çevirmek istiyor musunuz?",
    toActive: "Bu müşterinin durumunu inaktif'ten aktif'e çevirmek istiyor musunuz?",
    confirm: 'Evet, değiştir',
    cancel: 'Hayır',
    success: 'Müşteri durumu başarıyla güncellendi!',
    error: 'Müşteri durumu güncellenemedi!',
  },
  addresses: {
    title: 'Adresler',
    add: 'Yeni Adres Ekle',
    addTitle: 'Yeni Adres Ekle',
    editTitle: 'Adres Düzenle',
    empty: 'Henüz adres eklenmemiş',
    emptyHint: 'Müşterinin ofis, fabrika veya teslimat adreslerini buraya ekleyin.',
    count_one: '{{count}} adres',
    count_other: '{{count}} adres',
    default: 'Varsayılan',
    makeDefault: 'Varsayılan Adres',
    makeDefaultHint: 'Diğer adreslerin varsayılan işareti kaldırılır',
    deleteConfirm: 'Bu adres silinsin mi?',
    fields: {
      city: 'İl',
      district: 'İlçe',
      address: 'Adres',
      addressPlaceholder: 'Tam adres bilgisi',
      title: 'Başlık',
      titlePlaceholder: 'Örn: Merkez Ofis, Fabrika',
      postalCode: 'Posta Kodu',
      notes: 'Notlar',
      notesPlaceholder: 'Ek notlar',
    },
    required: 'Başlık ve adres alanları zorunludur',
    toast: {
      loadError: 'Adresler yüklenirken hata oluştu',
      added: 'Adres başarıyla eklendi',
      addError: 'Adres eklenirken hata oluştu',
      updated: 'Adres başarıyla güncellendi',
      updateError: 'Adres güncellenirken hata oluştu',
      deleted: 'Adres başarıyla silindi',
      deleteError: 'Adres silinirken hata oluştu',
    },
  },
  personnel: {
    title: 'Yetkililer',
    add: 'Yeni Yetkili Ekle',
    addTitle: 'Yeni Yetkili Ekle',
    editTitle: 'Yetkili Düzenle',
    empty: 'Henüz yetkili personel eklenmemiş',
    emptyHint: 'Müşteri tarafındaki iletişim kişilerini buraya ekleyin.',
    count_one: '{{count}} yetkili',
    count_other: '{{count}} yetkili',
    deleteConfirm: 'Bu yetkili silinsin mi?',
    fields: {
      firstName: 'Ad',
      lastName: 'Soyad',
      position: 'Pozisyon',
      department: 'Departman',
      email: 'E-posta',
      emailPlaceholder: 'E-posta adresi',
      phone: 'Telefon',
      phonePlaceholder: 'Telefon numarası',
      notes: 'Notlar',
      notesPlaceholder: 'Ek notlar',
    },
    required: 'Ad ve soyad alanları zorunludur',
    emailInvalid: 'Geçerli bir e-posta adresi girin',
    toast: {
      loadError: 'Yetkili personel yüklenirken hata oluştu',
      added: 'Yetkili personel başarıyla eklendi',
      addError: 'Yetkili personel eklenirken hata oluştu',
      updated: 'Yetkili personel başarıyla güncellendi',
      updateError: 'Yetkili personel güncellenirken hata oluştu',
      deleted: 'Yetkili personel başarıyla silindi',
      deleteError: 'Yetkili personel silinirken hata oluştu',
    },
  },
};

export default customers;
